import React from 'react';
import moment from 'moment';

import { baseTableColumn } from '@common/components/smartTable/helpers';
import VirtualsResultsPlayerName from '../components/playerName';

export const rowColumnConfig = () => [
  baseTableColumn('Id', 'game_id'),
  baseTableColumn('Round id', 'round_id'),
  {
    name: '1st place',
    row: (item) => <VirtualsResultsPlayerName data={item} position={0} />,
  },
  {
    name: '2nd place',
    row: (item) => <VirtualsResultsPlayerName data={item} position={1} />,
  },
  {
    name: '3rd place',
    row: (item) => <VirtualsResultsPlayerName data={item} position={2} />,
  },
  {
    name: 'Date',
    row: (item) => moment(item.date * 1000).format('DD-MM-YYYY HH:mm'),
  },
];
